import { keys } from 'ramda';
import { pickByTrue } from 'src/lib/pickByTrue';

export type SelectedMap = {
  [id: string]: boolean;
};

export const toSelectedOnlyArray = (x: SelectedMap) => keys(pickByTrue(x));
